import * as ActionTypes from 'store/actionTypes';

export const changeLicenceFilter = (customerId: string) => ({
  type: ActionTypes.SAVE_LICENCE_FILTER,
  payload: {customerId: customerId}
});
